const Box = ({ children, className = "", label }) => (
  <span title={label} aria-label={label} className={`h-7 px-2 inline-flex items-center justify-center rounded-[3px] text-[11px] font-bold leading-none ${className}`}>{children}</span>
);

export const PaymentLogos = () => (
  <div data-testid="payment-logos" className="flex flex-wrap items-center gap-1.5">
    <Box label="Swedbank" className="bg-[#FF5F00] text-white tracking-tight">Swedbank</Box>
    <Box label="SEB" className="bg-white text-[#60CD18] font-black text-sm tracking-wide">SEB</Box>
    <Box label="Luminor" className="bg-[#481335] text-white tracking-wide">Luminor</Box>
    <Box label="Visa" className="bg-white text-[#1A1F71] italic font-black text-sm">VISA</Box>
    <Box label="Mastercard" className="bg-white">
      <svg viewBox="0 0 32 20" className="h-4 w-auto"><circle cx="12" cy="10" r="8" fill="#EB001B" /><circle cx="20" cy="10" r="8" fill="#F79E1B" /><path d="M16 3.1a8 8 0 0 1 0 13.8 8 8 0 0 1 0-13.8z" fill="#FF5F00" /></svg>
    </Box>
    <Box label="Google Pay" className="bg-white text-[#3C4043] gap-0.5 text-[12px] font-medium">
      <span className="font-bold"><span className="text-[#4285F4]">G</span></span>Pay
    </Box>
    <Box label="Apple Pay" className="bg-black text-white border border-white/30 gap-0.5 text-[12px] font-medium">
      <svg viewBox="0 0 14 17" className="h-3.5 w-auto fill-white" aria-hidden="true"><path d="M11.6 9c0-2.2 1.8-3.2 1.9-3.3-1-1.5-2.6-1.7-3.2-1.7-1.4-.1-2.6.8-3.3.8-.7 0-1.7-.8-2.8-.8C2.8 4 1.5 4.9.8 6.2c-1.5 2.6-.4 6.4 1.1 8.5.7 1 1.5 2.2 2.6 2.1 1.1 0 1.5-.7 2.8-.7s1.6.7 2.8.7c1.2 0 1.9-1 2.6-2.1.8-1.2 1.2-2.4 1.2-2.4s-2.3-.9-2.3-3.3zM9.4 2.6c.6-.7 1-1.7.9-2.6-.8 0-1.9.6-2.5 1.3-.5.6-1 1.6-.9 2.6.9.1 1.9-.5 2.5-1.3z" /></svg>Pay
    </Box>
  </div>
);
